import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=c61a6590&scoped=true&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=c61a6590&scoped=true&lang=css&"
import style1 from "./PaginationControls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61a6590",
  null
  
)

export default component.exports